export const COMPONENT_TYPES = {
  RECENTLY_WATCHED: 'recentlywatched',
  CONTINUE_WATCHING: 'continuewatching',
};

export const GTM_EVENT_NAMES = {
  PAGE_VIEW: 'page_view',
  PAGE_VIEW_PPV: 'page_view_ppv',
  PLAYER: {
    WATCH_FROM_BEGINNING: 'watch_from_beginning',
    LANGUAGE: 'language',
    PAUSE: 'pause',
    PLAY: 'play',
    BACKWARD: 'backward',
    FORWARD: 'forward',
    NEXT_EPISODE: 'next_episode',
    NEXT_EPISODE_LOAD: 'next_episode_load',
    LIVE: 'live',
    MORE_CHANNELS: 'more_channels',
    CHANGE_AUDIO: 'change_audio',
    CHANGE_SUBTITLE: 'change_subtitle',
    CLOSE: 'close',
    OK: 'ok',
    YA_COMPRE_PPV: 'ya_compre_ppv',
    INTERACTIVITY: 'interactivity',
    TAPPP_PANEL: 'tappp_panel',
  },
  SETTINGS: {
    LOG_OUT: 'log_out',
    TERMS_AND_CONDITIONS: 'terms_and_conditions',
    PRIVACY_POLICY: 'privacy_policy',
    CONFIRM: 'confirm',
    CANCEL: 'cancel',
  },
  ACCOUNT: {
    CREATE_ACCOUNT: 'create_account',
  },
  LOGIN: {
    ENTER_LOGIN: 'enter_login',
    PIN_LOGIN_SUCCESS: 'pin_login_success',
  },
  PDP: {
    WATCH: 'watch',
    RESUME: 'resume',
    RESTART: 'restart',
    FILTER_TAB_PDP: 'filter_tab_pdp',
    SELECT_SEASON: 'select_season',
    WATCH_CONTENT: 'watch_content',
    WATCH_CHANNEL: 'watch_channel',
  },
  MENU: {
    LOG_OUT: 'log_out',
    BACK: 'back',
  },
  SEARCH: {
    CLEAR_SEARCH: 'clear_search',
    DEFAULT_CONTENT: 'default_content',
    RELATED_SEARCH_RESULT: 'related_search_result',
    RELATED_SEARCH_RESULT_NOT_FOUND: 'related_search_result_not_found',
  },
  PROFILES: {
    SELECT_PROFILE: 'select_profile',
    CREATE_PROFILE: 'create_profile',
    MANAGE_PROFILES: 'manage_profiles',
  },
  PROFILES_EDIT_CREATE: {
    SELECT_EDIT_PROFILE: 'select_edit_profile',
    CREATE_PROFILE: 'create_profile',
    MANAGE_PROFILES_BACK: 'manage_profiles_back',
  },
  PROFILES_CREATE_NAME: {
    BACK_PROFILES: 'back_profiles',
    CONTINUE_PROFILE: 'continue_profile',
    PAGE_VIEW_EDIT: 'page_view_edit',
    CONTINUE_PROFILE_EDIT: 'continue_profile_edit',
  },
  PROFILES_CREATE: {
    BACK_PROFILES: 'back_profiles',
    BACK_PROFILES_CREATE: 'back_profiles_create',
    CANCEL_PROFILES_CREATE: 'cancel_profiles_create',
    EDIT_NAME_PROFILE: 'edit_name_profile',
    CHANGE_ALLOWED_CONTENT_PROFILE: 'change_allowed_content_profile',
    SELECT_CREATE_PROFILE: 'select_create_profile',
    PAGE_VIEW_SUCCESS: 'page_view_success',
    PAGE_VIEW_ERROR: 'page_view_error',
    OK_ERROR_CREATE_PROFILE: 'ok_error_create_profile',
  },
  PROFILES_EDIT: {
    BACK_PROFILES: 'back_profiles',
    BACK_PROFILES_EDIT: 'back_profiles_edit',
    EDIT_NAME_PROFILE: 'edit_name_profile',
    CHANGE_ALLOWED_CONTENT_PROFILE: 'change_allowed_content_profile',
    CONFIRM_CREATE_PROFILE: 'confirm_edit_profile',
    DELETE_CREATE_PROFILE: 'delete_edit_profile',
    PAGE_VIEW_SUCCESS: 'page_view_success',
  },
  PROFILES_DELETE: {
    BACK_PROFILES: 'back_profiles',
    CONFIRM_DELETE_PROFILE: 'confirm_delete_profile',
    NOTNOW_DELETE_PROFILE: 'notnow_delete_profile',
    PAGE_VIEW_SUCCESS: 'page_view_success',
  },
  PROFILES_ONBOARDING: {
    CONTINUE_ONBOARDING: 'continue_onboarding',
    PAGE_VIEW_CREATE_NAME: 'page_view_create_name',
    CONTINUE_CREATE_NAME_ONBOARDING: 'continue_create_name_onboarding',
    PAGE_VIEW_CREATE_CONFIRMATION_ONBOARDING: 'page_view_create_confirmation_onboarding',
    CONTINUE_CREATE_CONFIRMATION_ONBOARDING: 'continue_create_confirmation_onboarding',
    EDIT_NAME_CONFIRMATION_ONBOARDING: 'edit_name_confirmation_onboarding',
    PAGE_VIEW_CREATE_SUCCESS_ONBOARDING: 'page_view_create_success_onboarding',
    PAGE_VIEW_ERROR_ONBOARDING: 'page_view_error_onboarding',
    CONTINUE_ERROR_ONBOARDING: 'continue_error_onboarding',
    TRY_AGAIN_ERROR_ONBOARDING: 'try_again_error_onboarding',
  },
  CAROUSELS: {
    WATCH_CAROUSELS: 'watch_carousels',
    SEE_MORE: 'see_more',
  },
  MY_LIST: {
    ADD: 'add',
    REMOVE: 'remove',
    WATCH: 'watch',
    BACK: 'back',
  },
  EPG: {
    FILTER_CATEGORY: 'filter_category',
    WATCH_CHANNEL: 'watch_channel',
    LIVE_NOW: 'live_now',
    NEXT_LIVE: 'next_live',
  },
  PARENTAL_CONTROL_ALLOW_CONTENT: {
    CONTINUE: 'continue',
    BACK: 'back',
  },
  PARENTAL_CONTROL_BLOCK_CONTENT: {
    OK: 'ok',
    CONSULT_SCHEDULE: 'consult_schedule',
    BACK: 'back',
    CLOSE: 'close',
  },
  TERMS_OF_SERVICE: {
    PAGE: 'page_view',
    ACCEPT: 'accept_terms',
    PAGE_VIEW_ERROR: 'page_view_error',
    CONTINUE_ERROR_TERMS: 'continue_error_terms',
  },
};

export const GTM_CATEGORIES = {
  HOME_DATA: 'home_data',
  LIVE_CATALOG_SPORTS_KIDS_PAGE_DATA: 'live_catalog_sports_kids_page_data',
  LOGIN_DATA: 'login_data',
  PLAYER_MOVIE_SERIE_LIVE_DATA: 'player_movie_serie_live_data',
  SETTINGS_DATA: 'settings_data',
  PDP_MOVIE_SERIE_LIVE_DATA: 'pdp_movie_serie_live_data',
  MENU_DATA: 'menu_data',
  SEARCH_DATA: 'search_data',
  PROFILES_DATA: 'profiles_data',
  CAROUSELS_DATA: 'carousels_data',
  NETWORK_AND_COLLECTION_PAGE_DATA: 'network_and_collection_page_data',
  MY_LIST_DATA: 'my_list_data',
  MY_PAGE_DATA: 'my_page_data',
  EPG_DATA: 'epg_data',
  PARENTAL_CONTROL_DATA: 'parental_control_data',
  ERRORS_DATA: 'errors_data',
  MODAL_DATA: 'modal_data',
  TERMS_OF_SERVICE_DATA: 'terms_of_service_data',
};

export const GTM_SUBCATEGORIES = {
  PAGES: {
    HOME: 'home',
    LIVE_PAGE: 'live_page',
    CATALOG_PAGE: 'catalog_page',
    SPORTS_PAGE: 'sports_page',
    KIDS_PAGE: 'kids_page',
    NETWORK_PAGE: 'network_page',
    COLLECTION_PAGE: 'collection_page',
    TERMS_OF_SERVICE_PAGE: 'terms_page',
  },
  SETTINGS: {
    SETTINGS: 'settings',
    LOG_OUT_CONFIRMATION: 'log_out_confirmation',
    PRIVACY_POLICY: 'privacy_policy',
    TERMS_AND_CONDITIONS: 'terms_and_conditions',
  },
  LOGIN: {
    HOME: 'login_home',
    ACTIVATION_OPTIONS: 'login_activation_options',
    REGISTER: 'login_register',
  },
  PLAYER: {
    MOVIE: 'player_movie',
    SERIE: 'player_serie',
    LIVE: 'player_live',
    AUDIO_AND_SUBTITLES: 'player_audio_and_subtitles',
    PLAYER_ERROR: 'player_error',
  },
  PDP: {
    MOVIES_WATCH: 'pdp_movies_watch',
    MOVIES_RELATED_CONTENT: 'pdp_movies_related_content',
    SERIE_WATCH: 'pdp_serie_watch',
    SERIE_SEASONS_AND_RELATED_CONTENT: 'pdp_serie_seasons_and_related_content',
    MOVIES_LIVE: 'pdp_movies_live',
  },
  MENU: 'menu',
  SEARCH: {
    SEARCH_DEFAULT_SCREEN: 'search_default_screen',
    SEARCH_RESULT: 'search_result',
    SEARCH_NOT_FOUND: 'search_not_found',
  },
  PROFILE: {
    PROFILES_PAGE: 'home_profiles',
    PROFILES_PAGE_EDIT_CREATE: 'home_profiles_edit_create',
    PROFILES_CREATE_NAME: 'profiles_create_name',
    PROFILES_CREATE: 'profiles_create',
    PROFILES_EDIT: 'profiles_edit',
    PROFILES_DELETE: 'profiles_delete',
    PROFILES_ONBOARDING: 'profiles_onboarding',
  },
  CAROUSELS: 'carousels',
  MY_LIST: {
    ADD_REMOVE: 'add_remove',
    LANDER: 'lander',
  },
  MY_PAGE: {
    LANDER: 'lander',
  },
  EPG: {
    EPG_LIVE_MINI_EPG: 'epg_live_mini_epg',
    SIMPLIFIED_EPG: 'simplified_epg',
  },
  ALLOW_CONTENT: 'allow_content',
  BLOCK_CONTENT: 'block_content',
  ERRORS: {
    ERROR_LOGOUT: 'error_logout',
  },
  MODAL: {
    INTERACTIVITY: {
      STEP_ONE: 'step_one',
      STEP_TWO: 'step_two',
    },
  },
};

export const GTM_ERROR_BLOCK_CONTENT = {
  PARENTAL_CONTROL: 'parental-control-content-block',
  GOOGLE_PLAY: 'google-play-content-block',
  NOT_IN_PACKAGE: 'not-in-package-content-block',
};

export const GTM_PLATFORMS_ERROR_CODES = {
  samsung: 'm9-1618(403)',
  lg: 'm10-1618(403)',
  hisense: 'm11-1618(403)',
  zeasn: 'm12-1618(403)',
};
